export default {
  namespaced: true,
  pbx_ip_block: {
    title: "Bloqueio de IPs",
    ip: "Endereço IP",
    ban_ip: "Bloquear um IP",
    ip_placeholder: "Ex. x.x.x.x",
    ban: "Bloquear",
    unban: "Desbloquear",
    unban_selected: "Desbloquear selecionados",
    empty: "Não há endereços IP bloqueados",
    loading: "Carregando endereços IP...",
    messages: {
      ban_success: "O IP {ip} foi bloqueado com sucesso",
      unban_success: "O IP {ip} foi desbloqueado com sucesso",
      bulk_success: "{count} endereços IP foram desbloqueados",
      bulk_error: "Não foi possível desbloquear {count} endereços IP",
    },
  },
};
